export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-stumbleupon-6ba379a49a438b930547543f7b6d210e.svg";